import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";

import api from "../../services/api";

function generateQueryString(params) {
  const query = new URLSearchParams();

  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      query.append(key, params[key]);
    }
  }

  return `?${query.toString()}`;
}

export const fetchFinishedFlows = createAsyncThunk(
  "activedflows/pagination/history",
  async ({ page, queries = {} }, { rejectWithValue }) => {
    const {
      filters = {
        title: "",
        client: "",
        alpha: false,
        creation: false,
        finishedAt: false,
      },
    } = queries;

    try {
      const query = generateQueryString(filters);

      const route = "/activedflows/pagination/history/" + page + "/" + query;

      const response = await api.get(route);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

const initialState = {
  pagination: {},
  pages: 1,
  status: "idle",
};

const finishedFlowsReducer = createReducer(initialState, {
  [fetchFinishedFlows.pending]: (state, action) => {
    state.status = "loading";
  },
  [fetchFinishedFlows.fulfilled]: (state, action) => {
    state.status = "succeeded";
    state.pagination = action.payload.activedflows;
    state.pages = action.payload.pages;
  },
});

export default finishedFlowsReducer;
